module.exports = "<ul id=\"m-callejerorest-results-list\">\n    {{#each places}}\n      <li id={{id}}><span>{{name}}</span></li>\n    {{/each}}\n</ul>\n";